import styled from 'styled-components'

import { SIZES } from '~/common/globalStyles'

interface FooterProps {
  brandName?: string
  hide?: boolean
}

const Footer = styled.div.attrs<FooterProps>(({ brandName = 'GUIDEcx' }) => ({
  children: `Ⓒ ${brandName} ${new Date().getFullYear()}`,
}))<FooterProps>`
  display: ${({ hide }) => (hide ? 'none' : 'block')};
  width: 100%;
  text-align: center;
  font-size: ${SIZES.small};
  padding: ${SIZES.medium} 0;
  margin-top: ${SIZES.xxl};
`

export default Footer
